<label [attr.for]="'Logo'">{{ ('Logo ID' | translate) + ':' }}</label>
<input id="logoId" type="text" [(ngModel)]="logoId">
<button (click)="onClick()">{{'Apply' | translate}}</button>